<script setup lang="ts">
import { AlertType } from '../../../../Constants/AlertType.ts'

const { type } = defineProps<{
  type: AlertType
}>()

const alertClasses: Record<string, boolean> = {
  alert: true,
  'alert-danger': type === AlertType.ERROR,
  'alert-warning': type === AlertType.WARNING,
  'alert-success': type === AlertType.SUCCESS,
}
</script>

<template>
  <div :class="alertClasses" role="alert">
    <div v-if="$slots.title" class="alert-heading" data-test="alert-title">
      <slot name="title"></slot>
    </div>
    <div class="alert-body" data-test="alert-body">
      <slot></slot>
    </div>
  </div>
</template>
